import React from 'react';

import { HeroView } from './hero/HeroView';
import { WhoWeAreView } from './whoWeAre/whoWeAre';
import { FoundersView } from './founders/foundersView';
import { ServicesList } from './servicesList/servicesList';
import { OurValuesView } from './ourValues/ourValuesView';
import { AboutUsReview } from './reviews/reviewsView';
import { HowItWorksView } from './howItWorks/howItWorks';
import { MarqueeView } from '@modules/layout/marquee/MarqueeView';

export const AboutUsView = () => {
  return (
    <>
      <HeroView />
      <WhoWeAreView />
      <FoundersView />
      <MarqueeView />
      <ServicesList />
      <OurValuesView />
      <AboutUsReview />
      <HowItWorksView />
    </>
  );
};
